module.exports = __webpack_public_path__ + "img/华南理工大学.19f1dff7.png";